import { render, staticRenderFns } from "./TopicsContentPage.vue?vue&type=template&id=25408342&scoped=true"
import script from "./TopicsContentPage.vue?vue&type=script&lang=js"
export * from "./TopicsContentPage.vue?vue&type=script&lang=js"
import style0 from "./TopicsContentPage.vue?vue&type=style&index=0&id=25408342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25408342",
  null
  
)

export default component.exports